import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

export interface HubspotTicket {
  id: number
  ticket_type: string
  ticket_status: string
  reqzipcode: string | null
  area_code: string | null
  ticket_priority: string
  opened_at: string
  updated_at: string
  ticket_requested_by: string | null
  external_id: string
  sales_representative_linq_user_id: string
  ticket_owner_linq_user_id: string
}

interface HubspotTicketsResponse {
  hubspot_tickets: HubspotTicket[]
}

const fetchOrganizationHubspotTickets = async (organizationId?: string) => {
  try {
    let response = await fetch(
      `${BASE_API_URL}/admin/api/v2/organizations/${organizationId}/hubspot_tickets`,
      {
        method: API_METHODS.GET,
        headers: apiHeaders(store.getState()),
      }
    )
    response = handleErrors(response)
    const json: HubspotTicketsResponse = await response.json()
    return json
  } catch (error) {
    console.error('error', error)
    throw error
  }
}

const useOrganizationHubspotTickets = (organizationId?: string) => {
  return useQuery<HubspotTicketsResponse, Error>(
    ['organizationHubspotTickets', organizationId],
    () => fetchOrganizationHubspotTickets(organizationId),
    {
      enabled: !!organizationId,
    }
  )
}

export default useOrganizationHubspotTickets
